import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  > div {
    margin-top: 16px;
  }
  > div + div {
    margin-top: 4px;
  }
`

interface IAnswerProps {
  correct?: boolean | null
  incorrect?: boolean | null
  disabled: boolean
}

export const Answer = styled.div<IAnswerProps>`
  font-size: 14px;
  color: #363636;
  font-weight: 500;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: fit-content;
  > div {
    transition: 200ms;
  }
  @media (max-width: 768px) {
    width: unset;
  }
  ${({ correct }) =>
    correct &&
    css`
      border: 1px solid #88e3bc;
      background: #d7f5e97a;
    `}
  ${({ incorrect }) =>
    incorrect &&
    css`
      border: 1px solid #f7a2a2;
      background: #fde0e07a;
    `}
  ${({ disabled }) =>
    disabled
      ? css`
          padding: 8px;
          cursor: not-allowed;
          label {
            cursor: not-allowed;
          }
        `
      : css`
          padding: 8px 0;
          cursor: pointer;
          &:hover {
            > div {
              opacity: 0.6;
            }
          }
        `}
  svg {
    font-size: 16px;
    margin-right: 8px;
    color: ${({ correct }) => (correct ? '#00B47C' : '#CF1322')};
  }
`
